import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getAuthSession, getAuthUser, getAuthUserPermissions, getAuthUserProfile } from "@/api/resources/auth/api";

export const authQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "auth"],
  getAuthSession: () => [...authQueryKeys.all(), "session"],
  getAuthUser: () => [...authQueryKeys.all(), "user"],
  getAuthUserProfile: (id?: string) => [...authQueryKeys.all(), "profile", id],
  getAuthUserPermissions: (id?: string) => [...authQueryKeys.all(), "permissions", id],
};

export const authQueries = {
  getAuthSession: () =>
    queryOptions({
      queryKey: [...authQueryKeys.getAuthSession()],
      queryFn: () => getAuthSession(),
    }),

  getAuthUser: () =>
    queryOptions({
      queryKey: [...authQueryKeys.getAuthUser()],
      queryFn: () => getAuthUser(),
    }),

  getAuthUserProfile: (id?: string) =>
    queryOptions({
      queryKey: [...authQueryKeys.getAuthUserProfile(id)],
      queryFn: id ? () => getAuthUserProfile(id) : skipToken,
    }),

  getAuthUserPermissions: (id?: string) =>
    queryOptions({
      queryKey: [...authQueryKeys.getAuthUserPermissions(id)],
      queryFn: id ? () => getAuthUserPermissions(id) : skipToken,
    }),
};
